import { BodyPrimary } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { PaginationFilter } from '@liveauctioneers/caterwaul-components/types/PaginationFilter';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import styled, { useTheme } from 'styled-components';

import SearchFollowSuggestions from '@/components/SearchFollowSuggestions/SearchFollowSuggestions';
import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';
import { useAppSelector } from '@/redux/hooks';
import {
    getTotalSavedSearches,
    isSavedSearchesLoading,
    savedSearchSearchesSelector,
} from '@/redux/modules/savedSearch';

import ManageSavedSearchFilter from './components/ManageSavedSearchFilter';
import ManageSavedSearchGrid from './components/ManageSavedSearchGrid';

type Props = {
    filters: PaginationFilter;
    onSavedSearchRecentFilterChange: (filters: PaginationFilter) => void;
};

const ManageSavedSearches = (props: Props) => {
    const { filters, onSavedSearchRecentFilterChange } = props;
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();
    const isMobile = useIsNarrowerThan(tabletNarrowWidthNum + 1);
    const isLoading = useAppSelector(isSavedSearchesLoading);
    const searches = useAppSelector(savedSearchSearchesSelector);
    const totalSavedSearchesCount = useAppSelector(getTotalSavedSearches);

    const preparedSavedSearchFilter = (
        <ManageSavedSearchFilter
            filters={filters}
            onFilterChange={onSavedSearchRecentFilterChange}
        />
    );

    return (
        <>
            {!isMobile && preparedSavedSearchFilter}
            <StyledManageSavedSearchGrid
                preparedSavedSearchFilter={preparedSavedSearchFilter}
                searches={searches}
            />

            {!isLoading && totalSavedSearchesCount === 0 && (
                <NoFollowed>
                    <FormattedMessage id="search_alerts.no_followed" />
                </NoFollowed>
            )}
            {totalSavedSearchesCount <= 0 && <StyledSearchFollowSuggestions useAltHeader />}
        </>
    );
};

export default ManageSavedSearches;

const NoFollowed = styled(BodyPrimary)`
    margin: 32px 0;
    text-align: center;
`;

const StyledSearchFollowSuggestions = styled(SearchFollowSuggestions)`
    width: 100%;

    & > div[class*='side-scroller'] {
        width: 100%;
    }

    & > div[class*='altHeader'] {
        margin: 0 0 20px;
    }
`;

const StyledManageSavedSearchGrid = styled(ManageSavedSearchGrid)`
    flex: 1 0 auto;
    margin-top: 32px;
    width: 100%;
    max-width: 100%;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidth}) {
        margin-top: 24px;
    }
`;
